import { api } from "../services/api";
import { apiLambda, getToken } from '../services/apiLambda';
import { IBaseBatchResponse, ICreateBatchConsultResponse } from "./types/BatchConsults";
import { ICreateBatchInstallmentsRequest, ICreateBatchInstallmentsResponse } from "./types/CreateBatchInstallments";
import { IDebts } from "./useDebts";

export interface IConsult {
    codigo: number;
    horario: string;
    mensagemEntrada: string;
    mensagemSaida: string;
    nome_consulta: string;
    uf: string;
    urlConsulta: string;
    campos: {
        codigo: number;
        conteudo: string;
    }[];
    consultData: any;
    debitos: {
        dpvat: ITickets[];
        ipva: ITickets[];
        licenciamento: ITickets[];
        multas: ITickets[];
        outros: ITickets[];
    };
    pagarTudo: boolean;
}


export interface ITickets {
    codigo: number;
    descricao: string;
    descricaoAdicional: string;
    emissor: string;
    expired: boolean;
    grupo: number;
    validade: string;
    valor: number;
    vencimento: string;
    disable?: boolean;
    ano?: number;
    unica?: boolean;
    quantidadeAno?: number;
    onCheck: {
        select: number[];
        unSelect: number[];
    };
    onUnCheck: {
        select: number[];
        unSelect: number[];
    };
}

interface IParams {
    vehicle: {
        id: number;
        uf: string;
        placa?: string;
        renavam?: string;
        document?: string;
    };
    tpDebt?: string;
    ip?: any;
    email?: string;
    origin?: string;
    clientSpecificCode?: number;
    tokenReCaptcha?: string;
    recoveryConsult?: boolean;
}

interface IUpdateConsultDTO {
    consulta: string;
    subUsuario: string | null;
    userPool: string | null;
    dataConsulta: object;
    payloadConsulta: object | null;
    payloadCaptura: object | null;
    payloadComprovante: object | null;
    status: string;
}

interface IConsultAPI {
    id: number;
    consulta: string;
    correlation: string;
    subUsuario: string;
    userPool: string;
    dataConsulta: string;
    placa: string;
    renavam: string;
    payloadConsulta: string;
    payloadCaptura: string;
    payloadComprovante: string;
    status: string;
}

export interface IErrorResponse {
    status: number;
    message: string;
}

export async function findConsultById(id: number) {
    const consult = await api
        .get<IConsultAPI>(`/find-consult/${id}`)
        .then((response) => response.data)
        .catch((e) => e?.response?.data?.message);

    return consult;
}

export const debtsFunction = async (data: IParams) => {
    try {
        const debts = await api.post(`${process.env.LAMBDA_DEBTS_QUERY}`, data, {
            headers: {
                terminal: process.env.REACT_APP_TERMINAL
            }
        });
        return {
            statusCode: debts.status,
            data: debts.data
        };
    } catch (err: any) {
        console.log('/services/debitos ==>', err);
        return {
            statusCode: err?.response?.status || 500,
            data: err?.response?.data || undefined
        };
    }
};

export async function updateConsult(data: IUpdateConsultDTO) {
    const updatedConsult = await api
        .put(`/update-consult/${data.consulta}`, data).then(response => response.data)
        .catch((e) => {
            console.error(`Error on updateConsult error: ${JSON.stringify(e)}`);
        });

    return updatedConsult;
}

export const sendDebtsToBackoffice = async (data: IDebts[], code: number) => {
    try {
        return await api.post(
            `/batch-payments/${code}`,
            data,
            {
                headers: {
                    tokenTerminal: process.env.REACT_APP_TERMINAL
                }
            }
        )
    } catch (err: any) {
        console.log('/services/debitos ==>', err);
        return {
            statusCode: err?.response?.status || 500,
            data: err?.response?.data || undefined
        };
    }
};

export const createBatchInstallments = async (
    batchCode: number,
    params: ICreateBatchInstallmentsRequest,
): Promise<ICreateBatchInstallmentsResponse | IBaseBatchResponse> => {
  const { data } = await apiLambda.post(`batch/installments/${batchCode}`, params);
  return data;
};
